module.exports = __webpack_public_path__ + "static/media/Clock.518708bc.svg";